import { render, staticRenderFns } from "./GetTransferRequests.vue?vue&type=template&id=5b5ca266"
import script from "./GetTransferRequests.vue?vue&type=script&lang=js"
export * from "./GetTransferRequests.vue?vue&type=script&lang=js"
import style0 from "./GetTransferRequests.vue?vue&type=style&index=0&id=5b5ca266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports